import { render, staticRenderFns } from "./editSkuDialog.vue?vue&type=template&id=3576c284&"
import script from "./editSkuDialog.vue?vue&type=script&lang=ts&"
export * from "./editSkuDialog.vue?vue&type=script&lang=ts&"
import style0 from "./editSkuDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports